import * as AppPics from 'assets/images';
import { Link } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import useGetSupportTickets from 'hooks/API/GET/useGetSupportTicket';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import { useState } from 'react';
import { notifier } from 'components/Toaster';
import { useQueryClient } from 'react-query';
import useSupportTicket from 'hooks/API/POST/useSupportTicket';

const actionsConfig = {
  open: false,
  data: {},
  Header: null,
  Body: null,
  isDeleteOperation: false,
};

function SupportTicket() {
  const queryClient = useQueryClient();
  const [actions, setActions] = useState({ ...actionsConfig });

  const { data } = useGetSupportTickets({ enabled: true });
  const ticketData = data?.data?.data?.result;

  const { mutate: manageSupportTicket } = useSupportTicket();

  const handleCloseTicket = (ticket) => {
    setActions({
      open: true,
      data: { ticketId: ticket.id },
      Header: 'Close Ticket',
      Body: `Are you sure you want to close the ticket?`,
      isDeleteOperation: true,
    });
  };

  const handleDeleteConfirm = () => {
    manageSupportTicket(
      {
        ticketId: actions.data.ticketId,
        isClose: true,
      },
      {
        onSuccess: (res) => {
          notifier.success(res?.data?.data?.message);
          queryClient.invalidateQueries('support-tickets');
        },
        onError: (err) => {
          notifier.error(err?.response?.data?.data?.message);
        },
      }
    );

    setActions({ ...actionsConfig });
  };

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteConfirm}
      />

      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back">
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Support Tickets', to: '/support/ticket' },
                ]}
                current="Tickets"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">
                        Manage Support Tickets
                      </h2>
                    </li>
                  </ul>

                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Ticket..."
                          type="text"
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="tab__contentBody">
                  <div className="tableWrap">
                    <div className="table-responsive">
                      <table className="table tableWrap__table">
                        <thead className="thead-light __appTheadColor">
                          <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Reference No.</th>
                            <th className="text-center">Issue Type</th>
                            <th className="text-center">Date</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {ticketData?.length > 0 ? (
                            ticketData.map((item, index) => (
                              <tr key={item?.id}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item?.referenceNo}</td>
                                <td className="text-center">{item?.issueCategory}</td>
                                <td className="text-center">{item?.date}</td>

                                <td
                                  className={`text-center fw-semibold ${
                                    item?.status === 'open'
                                      ? 'text-success'
                                      : item?.status === 'closed'
                                      ? 'text-danger'
                                      : item?.status === 'in-progress'
                                      ? 'text-warning'
                                      : ''
                                  }`}
                                >
                                  {item?.status}
                                </td>

                                <td className="text-center">
                                  <Link
                                    className="actions-icons mx-2 text-primary"
                                    title="View Details"
                                    to={`/support/ticket/${item?.id}`}
                                  >
                                    <img src={AppPics.EpisodePng} alt="View Ticket" />
                                  </Link>

                                  {item.status !== 'closed' && (
                                    <button
                                      className="actions-icons mx-2 text-danger"
                                      title="Close Ticket"
                                      onClick={() => handleCloseTicket(item)}
                                    >
                                      <img src={AppPics.DeleteSvg} alt="Close" />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6} className="text-center py-4">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Pagination Placeholder */}
                  {/* <TablePaginate /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupportTicket;
